import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@/i18n/config";

function AppWithAOS() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out-cubic",
      offset: 80,
    });

    // Routes are code-split (React.lazy), so a page's [data-aos] elements
    // often mount after this init's initial scan — without a re-scan they'd
    // stay stuck at opacity 0 until the user manually scrolls. Re-scan
    // whenever the DOM changes (route mount, list render, etc.), but throttle
    // hard: refreshHard() forces a layout reflow for every [data-aos] node,
    // so it must never run on every animation frame during an ongoing
    // animation (e.g. the homepage carousel), or it can dominate the main
    // thread.
    let timeout: ReturnType<typeof setTimeout> | null = null;
    const observer = new MutationObserver(() => {
      if (timeout !== null) return;
      timeout = setTimeout(() => {
        AOS.refreshHard();
        timeout = null;
      }, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return <App />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AppWithAOS />
    </BrowserRouter>
  </StrictMode>
);
